"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExceptionMessage = void 0;
var schemas_1 = require("@augloop/schemas/dist/src/client/schemas");
var isExceptionMessage = function (message) {
    if (message == null || message.messageType == null) {
        return true;
    }
    return (message.messageType == schemas_1.MessageType.Exception);
};
exports.isExceptionMessage = isExceptionMessage;
//# sourceMappingURL=imessage.js.map